<template>
  <div class="relative z-[200]">
    <Overlay :visible="isOpen" @click="close" />
    <Drawer
      class="w-full sm:w-[600px] p-4 pt-0 pb-8 flex flex-col h-[100dvh]"
      data-test-id="hubspot-form-sidebar"
      :is-open="isOpen"
      @click:close="close"
    >
      <template #header>
        <div
          class="h-14 flex items-center pr-8 text-lg font-medium text-[#666971]"
        >
          {{ title }}
        </div>
      </template>
      <LazyHubspotFormSidebarBody v-if="form" :form="form" />
    </Drawer>
  </div>
</template>

<script lang="ts" setup>
const { isOpen, close, formUrl, title } = useHubspotFormSidebarUiState()

// Gated on the form, not isOpen, so the embed stays mounted after closing.
const form = computed(() => parseHubspotShareUrl(formUrl.value))
</script>
